<template lang="html">
  <v-container>
    <router-view></router-view>
    <v-row>
      <v-col class="xs-12" cols="12">
        <v-card>
          <v-toolbar>
            <v-toolbar-title class="ml-3 mr-3">{{getBusiness.name}} Projects</v-toolbar-title>
            <v-spacer></v-spacer>
            <span v-if="hasBusinessPermission('Remove Projects')">
              <v-btn small :disabled="selection.length===0" v-if="projects_select" text color="red" @click="requestRemoveProjects()">Remove Projects</v-btn>
              <v-btn small @click="projects_select=!projects_select">{{ projects_select ? 'select' : 'route'}}</v-btn>
            </span>
          </v-toolbar>
          <v-row>
            <v-col xs12 class="members-setting-default-height">
              <div class="ml-5 mr-5">
                <v-row>
                  <StandardCard
                    v-for="project in getBusinessProjects"
                    :key="project.id"
                    :image="project.image"
                    :name="project.name"
                    :cols="4"
                    clickable="true"
                    @click.native="projectClick(project)"
                    >
                    <template #badge>
                      <StandardBadge
                      v-if="projects_select"
                      :show_icon_cond="isInSelection(project.id)"
                      show_icon="done"
                      color="white"
                      content_color="black"
                      />
                    </template>
                  </StandardCard>
                  <StandardCard
                    v-if="hasBusinessPermission('Add Projects')"
                    key="add_project_to_business"
                    icon="add"
                    :name="'Add Projects to ' + getBusiness.name"
                    :cols="4"
                    clickable="true"
                    @click.native="$router.push({ name: 'ConnectCompanyProjectsAddProject'})"
                    >
                  </StandardCard>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import StandardCard from '@/components/StandardComponents/StandardCard.component.vue'
import StandardBadge from '@/components/StandardComponents/StandardBadge.component.vue'
import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'CompanyManage',
  components: {
    StandardCard,
    StandardBadge
  },
  data: function () {
    return {
      selected_index: 0,
      show_delete: false,
      edit_role: false,
      business_roles: [],
      change_brole: {
        name: '',
        id: 0
      },
      add_new: false,
      new_member: {
        email: '',
        brole: {
          id: 0,
          name: ''
        }
      },
      projects_select: false,
      selection: []
    }
  },
  created(){
    this.business_roles = this.getBusinessRoles;
  },
  computed: {
    ...mapGetters('Auth', [
      'getUser'
    ]),
    ...mapGetters('Business', [
      'getBusiness',
      'getAddMemberError',
      'getBusinessProjects',
      'getBusinessMembers',
      'getBusinessRoles',
      'hasBusinessPermission'
    ])
  },
  methods: {
    ...mapActions('Business', [
      'removeUsersFromBusiness',
      'addUsers',
      'removeUsers',
      'updateMemberBRole',
      'removeProjects',
      'resetAddMemberError'
    ]),
    requestUpdateMemberBRole(payload){
      this.updateMemberBRole(payload);
      let self = this;
      setTimeout(function () {
        self.edit_role = false;
      }, 1500);
    },
    selectIndex(index){
      this.selected_index = index;
    },
    setNewUserEmail(event){
      this.new_member.email = event;
    },
    setNewUserBRole(event){
      this.new_member.brole = event;
    },
    selectOrDeselect(id){
      let index = this.selection.indexOf(id);
      if (index === -1) {
        this.selection.push(id);
      } else {
        this.selection.splice(index, 1);
      }
    },
    isInSelection(id){
      if (this.selection.indexOf(id) !== -1) {
        return true;
      } else {
        return false;
      }
    },
    projectClick(project){
      if (this.projects_select) {
        // select / deselect
        this.selectOrDeselect(project.id);
      } else {
        // route to project
        if (project.calling_user_is_member) {
          this.$router.push({name: 'Project', params: {project_id: project.id}});
        } else {
          this.$router.push({name: 'ConnectCompanyProjectsJoinProject', params: {project_id: project.id}});
        }
      }
    },
    requestRemoveProjects(){
      let projects = [];
      for (let i = 0; i < this.selection.length; i++) {
        projects.push({ id: this.selection[i]});
      }
      this.removeProjects({
        business_id: this.getBusiness.id,
        payload: {projects: projects}
      });
    },
    resetNewMember(){
      this.new_member = {
        email: '',
        brole: {
          id: 0,
          name: ''
        }
      };
      this.add_new = false;
    },
    resetMemberDetails(){
      this.selected_index = 0;
      this.show_delete = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.members-setting-default-height {
  max-height: 600px;
  overflow-y: auto;
}
.list-item-bg {
  background-color: red;
}
</style>
